// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBbqE_PmlrlgfDsF22rfXTIK9UbtN7TzBg",
    authDomain: "vetcant.firebaseapp.com",
    projectId: "vetcant",
    storageBucket: "vetcant.appspot.com",
    messagingSenderId: "1055785075404",
    appId: "1:1055785075404:web:4a8ed7b89403dcaa45f869",
    measurementId: "G-6PZHF55KKR"
  },
  apiUrl: "https://us-central1-vetcant.cloudfunctions.net/users/api/v1"
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
